// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorScale_wrapper__bsvrp","ruler":"ColorScale_ruler__icskj","scaleWrapper":"ColorScale_scaleWrapper__1QaXM","step":"ColorScale_step__KwGLb"};